// DO NOT EDIT THIS FILE
// The exports of this file is supposed to be overwritten by each app
// via the vite plugin. Your edits to this file would not be going to be
// used in the app.

const strings = {};

export { strings };
